import { render, staticRenderFns } from "./AdminBookmarks.vue?vue&type=template&id=6a4fd28e&scoped=true&"
import script from "./AdminBookmarks.vue?vue&type=script&lang=js&"
export * from "./AdminBookmarks.vue?vue&type=script&lang=js&"
import style0 from "./AdminBookmarks.vue?vue&type=style&index=0&id=6a4fd28e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4fd28e",
  null
  
)

export default component.exports